import React, { ReactNode } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import theme from './theme';

interface ThemeProviderProps {
  children: ReactNode;
}

/**
 * ThemeProvider component that wraps the application with the custom MUI theme
 * and applies CssBaseline for consistent styling across browsers
 */
export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};

export default ThemeProvider;
